import {hasRuntimeFlag} from '../../mesh/guards/hasRuntimeFlag';
import type {ThinChainLIneNodeMaterial} from '../ThinChainLineNodeMaterial';

/**
 * 判断目标值是否为点线点混合虚线 Node 材质。
 * 说明：
 * 1. 统一复用运行时标记判断，避免与具体构造函数强耦合；
 * 2. 该守卫只识别带 `isDashDotLIneNodeMaterial = true` 标记的材质；
 * 3. 后续正式构造线链路应优先使用该守卫，而不是直接 `instanceof LineDashedMaterial`。
 * @param value 待判断值。
 * @returns 当目标值为点线点混合虚线 Node 材质时返回 true。
 */
export function isDashDotLIneNodeMaterial(value: unknown): value is ThinChainLIneNodeMaterial {
    return hasRuntimeFlag(value, 'isDashDotLIneNodeMaterial');
}